import { AuthService } from '@/auth/service/auth.service';
import { CacheService } from '@/utils/cacheService/cache.service';
import { parseISOString } from '@/utils/parseISOString';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take, catchError, tap } from 'rxjs/operators';
import { EditingTaskToSend, PendingTasks } from '../../interfaces/task-user/task-user';

@Injectable({
  providedIn: 'root',
})
export class TaskDetailAndTotalTasksService {

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private cacheService: CacheService,
  ) { }

  getTotalTaskPending(mdmid: string): Observable<PendingTasks[]> {
    const roleId = this.auth.getUserRoleId();
    const source$ = this.http.get<PendingTasks[]>(`Task/PendingTasks?rutDv=${mdmid}&userRolId=${roleId}`)
      .pipe(
        map((value) => value.map(({ notificationDate, ...otherKeys }) => (
          { ...otherKeys, notificationDate: parseISOString(<string>notificationDate) }
        )).sort((a, b) => <number><unknown>a.notificationDate - <number><unknown>b.notificationDate)),
      );
    return this.cacheService.save<PendingTasks[]>(`getTotalTaskPending${mdmid}`, 1, source$);
  }

  getTotalTaskPendingCount(mdmid: string): Observable<number> {
    return this.getTotalTaskPending(mdmid)
      .pipe(map((a) => a.length));
  }

  taskUpdate(requirementId: number, documentsModified: EditingTaskToSend[]): Observable<any> {
    this.cacheService.remove('getRequestApprovalPending');
    this.cacheService.remove('getTotalTaskPending');
    this.cacheService.remove('getDetailsAll');
    return this.http.post(`Task/UpdateDocumentsRequirement/${requirementId}`, documentsModified)
      .pipe(take(1));
  }
}
export interface TaskUser {
  pendingTask: number;
}
